import { formatMoney, formatReturn, returnClass } from '../utils/portfolio';
import Avatar from './Avatar.jsx';
import './ProfileCard.css';

/**
 * The storefront-style identity card: photo, name, bio, credentials, stats, tags.
 * `actions` is whatever buttons the caller wants (Follow, Edit profile...).
 * Used by ProfilePage and as the live preview on EditProfilePage.
 */
export default function ProfileCard({ user, actions = null, showStats = true }) {
  const p = user.portfolio || {};
  const sub = [user.location, user.investingSince && `Investing since ${user.investingSince}`]
    .filter(Boolean)
    .join(' · ');

  return (
    <section className="card profile-card" aria-label={`About ${user.name}`}>
      <Avatar user={user} size={112} decorative={false} />
      <div>
        <h1 className="profile-card__name">{user.name}</h1>
        {sub && <p className="profile-card__sub">{sub}</p>}
      </div>
      {user.bio && <p className="profile-card__bio">{user.bio}</p>}

      {user.credentials?.length > 0 && (
        <ul className="chips profile-card__chips" aria-label="Credentials">
          {user.credentials.map((c) => <li key={c} className="chip">{c}</li>)}
        </ul>
      )}

      {showStats && (
        <div className="profile-card__stats tnum">
          {p.showValue && (
            <div>
              <div className="profile-card__stat">{formatMoney(p.value || 0)}</div>
              <div className="profile-card__stat-label">Portfolio</div>
            </div>
          )}
          <div>
            <div className={`profile-card__stat ${returnClass(p.return1y || 0)}`}>{formatReturn(p.return1y || 0)}</div>
            <div className="profile-card__stat-label">1Y return</div>
          </div>
          <div>
            <div className="profile-card__stat">{user.followerCount ?? 0}</div>
            <div className="profile-card__stat-label">Followers</div>
          </div>
        </div>
      )}

      {actions}

      {user.tags?.length > 0 && (
        <ul className="chips profile-card__chips" aria-label="Investing style">
          {user.tags.map((t) => <li key={t} className="chip chip--soft">{t}</li>)}
        </ul>
      )}
    </section>
  );
}
